<template>
  <v-layout>
    <div class="col">
      <div class="head-page-title hide-for-small-only">
        <h1 class="main-title">Mijn passen</h1>
      </div>
      <div class="panel">
        <div class="row">
          <div class="small-12 columns">
            <card-filter-form @submit="loadData"/>
            <br clear="all">
            <nav class="toolbar">
              <ul/>
            </nav>
            <div class="datatable-wrapper">
              <div class="dataTables_wrapper dt-foundation no-footer">
                <table class="datatable datatable-row-click dataTable no-footer" role="grid"
                       style="width: 800px;">
                  <thead>
                    <table-header :order-by="orderBy"
                                  :order-direction="orderDirection"
                                  :columns="headerColumns"
                                  translation-prefix="card.headerColumns."
                                  @orderingChanged="setOrderingAndLoadData"/>
                  </thead>
                  <tbody>
                    <tr is="card-list-item"
                        v-for="cardSummary in companyCards"
                        :card="cardSummary"
                        :key="cardSummary.engraved_id"/>
                    <tr v-if="!companyCards || companyCards.length === 0">
                      <td colspan="4">Geen resultaten</td>
                    </tr>
                  </tbody>
                </table>
                <div class="bottom">
                  <div class="dataTables_paginate paging_full_numbers">
                    <card-list-paginator :page-size="pageSize" @paginationChanged="loadData"/>
                  </div>
                  <div class="dataTables_length">
                    <label>
                      <select-input
                        id="page_size"
                        :value="'' + pageSize"
                        :options="pageSizeOptions"
                        :$v="$v.pageSize"
                        name="page-size"
                        @change="setPageSize"
                      />
                      items per pagina
                    </label>
                  </div>
                </div>
                <div class="clear"/>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import $ from 'jquery'
import VLayout from '../layouts/Default'
import 'bower/foundation/js/foundation.js'
import { mapState } from 'vuex'
import CardListItem from '../components/cards/CardListItem'
import CardListPaginator from '../components/cards/CardListPaginator'
import CardFilterForm from '../components/forms/CardFilterForm'
import EngravedId from '../components/forms/fields/EngravedId'
import SelectInput from '../components/forms/fields/SelectInput'
import {
  SET_COMPANY_CARDS_PAGE_SIZE,
  SET_ORDER_BY,
  SET_ORDER_DIRECTION
} from '../store/modules/card/mutation-types'
import showAlertErrorHandler from '../mixins/show-alert-error-handler'
import {buildTableHeaderColumn} from '../types/table-header-column'
import TableHeader from '../components/tableHeader/TableHeader'

export default {
  name: 'CardPage',
  components: {
    SelectInput,
    EngravedId,
    CardListPaginator,
    VLayout,
    CardListItem,
    CardFilterForm,
    TableHeader
  },
  mixins: [showAlertErrorHandler],
  data: () => ({
    pageSizeOptions: [
      { value: '10', text: '10' },
      { value: '25', text: '25' },
      { value: '50', text: '50' },
      { value: '100', text: '100' }
    ],
    headerColumns: [
      buildTableHeaderColumn('engravedId', '194px'),
      buildTableHeaderColumn('ascription', '218px'),
      buildTableHeaderColumn('ascription1', '166px'),
      buildTableHeaderColumn('ascription2', '166px')
    ]
  }),
  computed: {
    ...mapState({
      companyCards: state => state.card.companyCardsForCurrentFilter,
      pageSize: state => state.card.companyCardsPageSize,
      currentPage: state => state.card.companyCardsCurrentPageNumber,
      orderBy: state => state.card.orderBy,
      orderDirection: state => state.card.orderDirection
    })
  },
  mounted () {
    if (typeof $(document).foundation === 'function') {
      $(document).foundation()
    }
    if (typeof $.foundation === 'function') {
      $.foundation('tab', 'reflow')
    }
    this.loadData()
  },
  validations () {
    return {
      pageSize: {}
    }
  },
  methods: {
    loadData: async function () {
      try {
        await this.$store.dispatch('card/loadCompanyCards')
      } catch (error) {
        this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
      }
    },
    setPageSize: function (value) {
      value = parseInt(value)
      this.$store.commit(`card/${SET_COMPANY_CARDS_PAGE_SIZE}`, value)
      this.loadData()
    },
    setOrderingAndLoadData (ordering) {
      this.$store.commit(`card/${SET_ORDER_BY}`, ordering.orderBy)
      this.$store.commit(`card/${SET_ORDER_DIRECTION}`, ordering.orderDirection)
      this.loadData()
    }
  }
}
</script>

<style scoped>
  ul.tabs li.tab-title a:focus {
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/CardPage.vue